module.exports = __webpack_public_path__ + "img/SA.ac6c5dcf.svg";